import { FunctionComponent } from "react";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { ERROR_TYPE, getAllErrors, renderErrorMessages } from "@/utils";

import { Button } from "@/components/Button/Button";
import { ButtonColor } from "@/components/Button/types";

interface LiPostFormActionsProps {
	buttonTitle: string;
	isLoading: boolean;
	formErrors: ERROR_TYPE[];
	serverError: FetchBaseQueryError | SerializedError | undefined;
	onSubmit: () => void;
	onCancel?: () => void;
}

/** Aggregated error messages + sticky cancel/submit footer for the LiPost form. */
export const LiPostFormActions: FunctionComponent<LiPostFormActionsProps> = ({
	buttonTitle,
	isLoading,
	formErrors,
	serverError,
	onSubmit,
	onCancel,
}) => {
	const allErrors = getAllErrors(serverError, formErrors);

	return (
		<>
			<div className="flex flex-row gap-4 w-full mb-4">
				{allErrors.length ? renderErrorMessages(allErrors) : null}
			</div>
			<div className="flex gap-4 justify-end sticky bottom-8 z-20 w-[calc(100%+2rem)] rounded-b-xl -ml-4 -mr-8 px-4 py-3 bg-brand-white border-t border-gray-200">
				{onCancel && (
					<div className="flex max-w-[100px] w-full">
						<Button
							className="w-full"
							color={ButtonColor.ACTION_SECONDARY}
							title="cancel"
							onClick={onCancel}
						/>
					</div>
				)}

				<div className="flex w-auto">
					<Button className="w-full" isLoading={isLoading} title={buttonTitle} onClick={onSubmit} />
				</div>
			</div>
		</>
	);
};
